import React, { Component, Fragment } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import {
  EditableTextField,
  EditableSwitch,
  EditableReactSelect,
  EditableReactSelectAsyncCreatable,
  EditableSelect,
} from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import _ from 'lodash'

const EXCHANGE = 'Exchange'
const STORAGE = 'Storage'
export default class InventoryItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChangeRegions = (regions) => {
    const { data = {} } = this.props
    if (data.name === EXCHANGE) {
      const { availableApps = [] } = this.props.companyFeatures || {}
      if (availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') >= 0) {
        return
      }
    }
    const regionIds =
      (regions &&
        regions.map((region) => {
          return region.value
        })) ||
      []
    this.props.onChange('regionIds', regionIds)
  }

  newOnchange = (regions) => {
    const newValue = [regions[regions.length > 0 ? regions.length - 1 : 0]]
    const regionIds = newValue && newValue.map((item) => (item && item.value) || '')
    this.props.onChange('regionIds', regionIds)
  }

  render() {
    const {
      data = {},
      editMode,
      regions,
      complianceRoomOptions = [],
      isComplianceRoomsEnabled = false,
    } = this.props
    const regionOptions = regions
      .filter((region) => region.active)
      .map((region) => {
        return { label: region.name, value: region.id }
      })
    const selectedRegions =
      (regions &&
        regions.filter((region) => {
          return data.regionIds.find((regionId) => region.active && region.id === regionId)
        })) ||
      []
    const permitted = hasAccess()
    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.id}
            editMode={false}
            value={data.id}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={data.type !== STORAGE && editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          {
            <EditableReactSelect
              multi={true}
              valueToRender={selectedRegions.map((region) => region.name).join(', ')}
              editMode={editMode}
              value={selectedRegions.map((region) => ({ label: region.name, value: region.id }))}
              onChange={this.onChangeRegions}
              type="text"
              InputLabelProps={{
                shrink: true,
              }}
              options={regionOptions}
            />
          }
        </TableCell>
        {isComplianceRoomsEnabled ? (
          <TableCell className="cell-wrap-word">
            <EditableSelect
              valueToRender={data.complianceInvRoomName || ' '}
              editMode={complianceRoomOptions.length === 0 ? false : editMode}
              type={'text'}
              value={data.complianceInvRoomId}
              onChange={(e) => {
                let value = e.target.value
                let roomName =
                  (_.find(this.props.complianceRoomOptions || [], { id: value }) || {}).name || ' '
                this.props.onChange('complianceInvRoomName', roomName)
                this.props.onChange('complianceInvRoomId', value)
              }}
            >
              {(this.props.complianceRoomOptions || []).map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
              {data.complianceInvRoomId === 0 || _.isNull(data.complianceInvRoomId) ? null : (
                <MenuItem style={{ color: 'red' }} value={0}>
                  Clear
                </MenuItem>
              )}
            </EditableSelect>
          </TableCell>
        ) : null}
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.numTerminals}
            editMode={false}
            value={data.numTerminals}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.active ? 'Active' : 'Inactive'}
            checked={data.active}
            editMode={data.type !== STORAGE && editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          {permitted ? (
            <Fragment>
              {data.name !== EXCHANGE ? (
                <EditActionComponent
                  onSave={this.onSave}
                  onCancel={this.onCancel}
                  onEdit={this.props.enableEdit}
                  editMode={editMode}
                />
              ) : null}

              {data.type !== STORAGE && !editMode ? (
                <Button className="danger-button margin" onClick={this.props.onDelete}>
                  Delete
                </Button>
              ) : null}
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Inventory/InventoryItem.js